import { WeekRangeObj } from "@/components/Search/types";

function getWeekRangeFilters(weeksToCompleteRange: WeekRangeObj) {
  if (
    !weeksToCompleteRange ||
    weeksToCompleteRange.startWeek == null ||
    weeksToCompleteRange.endWeek == null
  ) {
    return "";
  }

  const startWeek = weeksToCompleteRange.startWeek;
  const endWeek = weeksToCompleteRange.endWeek;

  if (
    !Number.isInteger(startWeek) ||
    !Number.isInteger(endWeek) ||
    startWeek < 0 ||
    endWeek < 0 ||
    startWeek > endWeek
  ) {
    return "";
  }

  const filters = [];
  for (let i = startWeek; i <= endWeek; i++) {
    filters.push(`weeks_to_complete:${i}`);
  }

  return filters.length > 0 ? filters.join(" OR ") : "";
}

export default getWeekRangeFilters;
